import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { I18nProvider } from './lib/i18n';
import Home from './pages/Home';
import Admin from './pages/Admin';
import { PaymentSuccess, PaypalSuccess, PaymentCancel } from './pages/Payment';

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/paypal/success" element={<PaypalSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            classNames: {
              toast: 'rounded-2xl border border-black/5 shadow-lg',
            },
          }}
        />
      </div>
    </I18nProvider>
  );
}

export default App;
